import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const ModalContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 28px;
  padding: 26px 0;
  width: 80vw;
  height: 80vh;
  max-width: 90vw;
  max-height: 90vh;
  box-sizing: border-box;

  @media (max-width: ${props => props.theme.mediaQuery.mobile}) {
    width: 90vw;
    height: auto;
    max-height: 80vh;
  }
`

export const ModalImageWrapper = styled.div`
  width: 90%;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  background: #fff;
  border-radius: 28px;
`

export const ModalImageGatsby = styled( GatsbyImage )`
  max-width: 100%;
  max-height: 100%;
  background: #fff;
  border-radius: 28px;
  object-fit: contain;
  display: block;

  img {
    margin: auto;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: contain !important;
    border-radius: 28px !important;
    width: auto !important;
    height: auto !important;
    display: block !important;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 22px;
  right: 22px;
  background: rgba(0,0,0,0.6);
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${props => props.theme.mediaQuery.mobile}) {
    top: 8px;
    right: 8px;
    width: 26px;
    height: 26px;
  }
`
